const status = [
  {
    title: 'Dalam Antrian',
    historyTitle: 'Komplain dalam antrian',
    value: '11_queued',
    color: 'grey',
  },
  {
    title: 'Diproses CS',
    historyTitle: 'Diproses CS Smartlink',
    historySubtitle: 'Komplain sedang diproses oleh ',
    value: '21_process_cs',
    color: 'yellow',
  },
  {
    title: 'Diproses E-Wallet',
    historyTitle: 'Dalam penanganan pihak E-wallet',
    historySubtitle: 'Komplain sedang ditangani oleh ',
    value: '22_process_ewallet',
    color: 'yellow',
    
  },
  {
    title: 'Perlu Refund',
    historyTitle: 'Dana telah diteruskan ke Owner',
    historySubtitle: 'Menunggu konfirmasi refund oleh owner/kasir',
    value: '31_need_refund',
    color: 'yellow',
  },
  {
    title: 'Komplain Selesai',
    historyTitle: 'Dana telah direfund ke Customer',
    value: '32_done',
    color: 'green',
  },
  {
    title: 'Komplain Ditolak',
    historyTitle: 'Komplain Ditolak',
    value: '41_rejected',
    color: 'red',
  },
];
export default status;